import { styled } from "styled-components";
import { BlueBirdTheme } from "@kitbird/core";
import rightCornerBg from "../../assets/images/right_corner_bg.svg";

const AppWrapper = styled.div`
  height: 100vh;
  display: flex;

  background-attachment: fixed;
  background-position: bottom right; 
  background-image: url(${rightCornerBg});  
  background-color: ${BlueBirdTheme.colors.primary[200]};
  background-repeat: no-repeat;
`;

export default AppWrapper;
